module.exports = __webpack_public_path__ + "img/brse.ed10408d.svg";